import { Component } from '@angular/core';
import { DrawresultService } from '../../services/drawresult.service';
import Swal from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'app-draw',
  templateUrl: './draw.component.html',
  styleUrls: ['./draw.component.scss'],
})
export class DrawComponent {
  constructor(private drawServ: DrawresultService) {}
  games = [
    { name: 'STL', value: 'STL' },
    { name: '2D', value: '2D' },
    { name: '3D', value: '3D' },
  ];
  gamevalue: any = '3D';

  time: any = [];
  timevalue: any = null;

  inputText2D3D: boolean = false;
  date: string = new Date()
    .toLocaleString('en-US', {
      timeZone: 'Asia/Manila',
    })
    .split(',')[0];

  result3D: any = null;
  resultSTL2D_1: any = null;
  resultSTL2D_2: any = null;

  time24format: any;

  results: any;
  visible: boolean = false;
  value: string = '';

  ngOnInit() {
    console.log(moment().hours());
    this.LoadDrawResult();
    this.SelectGame();
  }

  LoadDrawResult() {
    this.drawServ.getResult().subscribe((res: any) => {
      // console.log(res);
      this.results = res;
    });
  }
  onClickAdd() {
    this.visible = true;
  }

  SelectGame() {
    switch (this.gamevalue) {
      case 'STL':
        this.time = [{ value: '11AM' }, { value: '4PM' }, { value: '9PM' }];
        this.inputText2D3D = true;
        break;
      case '2D':
        this.time = [{ value: '2PM' }, { value: '5PM' }, { value: '9PM' }];
        this.inputText2D3D = true;
        break;
      case '3D':
        this.time = [{ value: '2PM' }, { value: '5PM' }, { value: '9PM' }];
        this.inputText2D3D = false;
        break;
    }
  }
  SelectTime = () => {
    switch (this.gamevalue) {
      case '11AM':
        this.time24format = 11;
        break;
      case '4PM':
        this.time24format = 16;
        break;
      case '8PM':
        this.time24format = 20;
        break;
      case '2PM':
        this.time24format = 14;
        break;
      case '5PM':
        this.time24format = 17;
        break;
      case '9PM':
        this.time24format = 21;
        break;
    }
  };

  CleartextBox() {
    this.result3D = null;
    this.visible = false;
  }
  Save() {
    let data = {
      date: this.date,
      game: this.gamevalue,
      time: this.timevalue,
      result:
        this.gamevalue == '3D'
          ? this.result3D
          : this.addZero(this.resultSTL2D_1) + '*' + this.addZero(this.resultSTL2D_2),
    };
    if (this.AddValidation()) {
      this.drawServ.Add(data).subscribe((res: any) => {
        if (res.flag == 1) {
          Swal.fire({
            icon: 'success',
            title: 'SUCCESS',
            text: res.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.CleartextBox();
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'NOTICE',
            text: res.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
        this.LoadDrawResult();
      });
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'NOTICE',
        text: 'Fill-up all fields',
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }
  addZero = (number :string) =>{
    return number.length == 1 ? "0" + number : number
  }
  AddValidation() {
    let result;
    if (this.date != null || this.gamevalue != null || this.timevalue != null) {
      switch (this.gamevalue) {
        case 'STL':
        case '2D':
          if (this.resultSTL2D_1 != null && this.resultSTL2D_2 != null) {
            result = true;
          } else {
            result = false;
          }
          break;
        case '3D':
          if (this.result3D != null) {
            result = true;
          } else {
            result = false;
          }
          break;
      }
    } else {
      result = false;
    }
    return result;
  }
}
